import styled from 'styled-components';

export const Container = styled.main`
  grid-area: graph_map;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 930px;
  margin-left: 25px;
   @media (max-width: 1440px) {
    width: 70%;

  }
`;
